export default __webpack_public_path__ + "static/media/salmon.a873ba35.png";